import { useEffect, useState } from 'react';
import { greetingRefreshDelayMs } from '@/utils/greeting';

/**
 * Current local time, re-evaluated at the next greeting-period boundary
 * (and at least every minute) so a dashboard left open does not keep
 * yesterday's greeting after 09:00 / 12:00 / 18:00 / midnight.
 */
export function useGreetingNow(): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    let timeoutId: number;

    const tick = () => {
      setNow(new Date());
    };

    const schedule = () => {
      timeoutId = window.setTimeout(() => {
        tick();
        schedule();
      }, greetingRefreshDelayMs());
    };

    const onVisible = () => {
      if (document.visibilityState !== 'visible') return;
      window.clearTimeout(timeoutId);
      tick();
      schedule();
    };

    schedule();
    document.addEventListener('visibilitychange', onVisible);
    window.addEventListener('focus', onVisible);
    return () => {
      window.clearTimeout(timeoutId);
      document.removeEventListener('visibilitychange', onVisible);
      window.removeEventListener('focus', onVisible);
    };
  }, []);

  return now;
}
